export type Lang = "en" | "de"

export const LANGS: readonly Lang[] = ["en", "de"]

export const LOCALES: Record<Lang, string> = { en: "en-GB", de: "de-DE" }

const STORAGE_KEY = "clvr.lang"

export type Params = Record<string, string | number>

/** A namespace holds the same keys in both languages; a missing German key fails the type check. */
export function defineMessages<const K extends string>(messages: { en: Record<K, string>; de: Record<K, string> }) {
  return messages
}

export function detectLang(): Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === "en" || stored === "de") return stored
  } catch {
    // storage blocked: fall through to the browser language
  }
  const browser = typeof navigator !== "undefined" ? navigator.language : ""
  return browser.toLowerCase().startsWith("de") ? "de" : "en"
}

export function persistLang(lang: Lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang)
  } catch {
    // storage blocked: the choice only lasts for this session
  }
}

export function interpolate(template: string, params?: Params): string {
  if (!params) return template
  return template.replace(/\{(\w+)\}/g, (match, name: string) => (name in params ? String(params[name]) : match))
}
